import React from 'react'

function Upload(props) {
    const iconColor=props.iconColor;
    const iconSize=props.iconSize;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={iconSize || "11"} height={iconSize || "11"} style={{margin:"0 3px",color:iconColor,height:iconSize,width:iconSize}}  viewBox="0 0 11 11" >
        <defs>
        </defs>
        <g transform="translate(-4 -4)" >
        <path class="a" fill="none" stroke={ iconColor || "#fff"} strokeLinecap="round" strokeLineJoin="round" d="M14.5,22.5v2.222a1.111,1.111,0,0,1-1.111,1.111H5.611A1.111,1.111,0,0,1,4.5,24.722V22.5" transform="translate(0 -11.333)"/>
        <path class="a" fill="none" stroke={ iconColor || "#fff"} strokeLinecap="round" strokeLineJoin="round" d="M16.056,7.278,13.278,4.5,10.5,7.278" transform="translate(-3.778)"/>
        <path class="a" fill="none" stroke={ iconColor || "#fff"} strokeLinecap="round" strokeLineJoin="round" d="M18,4.5v6.667" transform="translate(-8.5)"/>
        </g>
        </svg>
    )
}

export default Upload
